<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addInstagram">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        ref="dragTable"
        :scroll="{ y: 'calc(100vh - 300px)' }"
        row-key="id"
        :data-source="table.data"
        :columns="table.columns"
        :loading="table.loading"
        @change="handleTableChange"
        :pagination="{
            current: table.query.page,
            pageSize: table.query.size,
            total: table.query.total,
            showSizeChanger: true,
            showLessItems: true,
            pageSizeOptions: ['5','10','30','50','100'],
            showQuickJumper: true,
            showTotal: (total,range)=> `第 ${range[0]} - ${range[1]} 条，总计 ${total} 条`,
            onChange:  onPageChange,
            onShowSizeChange: onSizeChange
        }"
      >
        <span slot="img" slot-scope="text, record">
           <a-avatar :size="80" shape="square" :src="record.mediaUrl"/>
        </span>
        <span slot="isShow" slot-scope="text, record">
            <a-tag type="success" color="blue" v-if="record.isShow==='YES'">是</a-tag>
            <a-tag type="danger" v-if="record.isShow==='NO'">否</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="instagramDetail(record.id)">详情</a-button>
          <a-button type="link" @click="editInstagram(record.id)">{{ $t('EDIT') || '编辑' }}</a-button>
          <a-button type="link" @click="deleteInstagram(record.id)">{{ $t('DELETE') || '删除' }}</a-button>
        </span>
        <template slot="sort">
          <a-icon type="drag" style="font-size: 25px;"/>
        </template>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      title="详情"
      v-model="form.visible">
      <instagram-edit
        v-if="form.visible"
        :instagram-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </instagram-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryGoodsInstagrams,
  _deleteGoodsInstagram,
  _updateGoodsSort,
} from '@/api/websiteGoodsInstagramApi';
import Sortable from 'sortablejs';
// import ImageCardRow from '@/components/CommonUtils/ImageCardRow.vue';
import InstagramEdit from './InstagramEdit.vue';

async function getInstagramList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsInstagrams({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
  this.table.loading = false;
}

function addInstagram() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editInstagram(instagramId) {
  this.form.data.id = instagramId;
  this.form.visible = true;
}

function instagramDetail(instagramId) {
  this.$router.push(`/instagram/${instagramId}/positions`);
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getInstagramList();
}

function handleTableChange(pagination, filters, sorter) {
  this.table.query.page = pagination.current;
  this.table.query.size = pagination.pageSize;
  if (sorter.field) {
    this.table.sort = {
      prop: sorter.field,
      order: sorter.order,
    };
  }
  this.getInstagramList();
}

function handleSizeChange(current, pageSize) {
  this.table.query.page = current;
  this.table.query.size = pageSize;
  this.getInstagramList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getInstagramList();
}

async function deleteInstagram(instagramId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoodsInstagram(instagramId);
      this.$message.success('删除成功');
      await this.getInstagramList();
    },
  });
}

async function updateSortList(oldIndex, newIndex) {
  const idStr = this.table.data.map(x => x.id).join(',')
  const sortStr = this.table.data.map(x => x.sort).join(',')
  const result = await _updateGoodsSort({
    idStr,
    sortStr,
    oldIndex,
    newIndex
  })
  if (result) {
    this.$message.success('移动排序成功')
    await this.getInstagramList()
  }
}

function initSortable() {
  const el = this.$refs.dragTable.$el.querySelector('.ant-table-tbody')
  const dragTable = Sortable.create(el, {
    handle: 'td:nth-child(2)',
    animation: 150,
    // 利用更新
    onUpdate: (e) => {
      const oldIndex = e.oldIndex
      const newIndex = e.newIndex
      if (oldIndex === newIndex) return
      this.updateSortList(oldIndex, newIndex)
    },
  })
}

const columns = [
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '是否展示',
    scopedSlots: { customRender: 'isShow' }
  },
  {
    title: '拖拽排序',
    align: 'center',
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'InstagramList',
  components: {
    // ImageCardRow,
    InstagramEdit,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns,
        data: [],
        loading: false,
        tip: '加载中...',
        query: {
          page: 1,
          size: 10,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'DESC',
        },
      },
    };
  },
  methods: {
    getInstagramList,
    deleteInstagram,
    editInstagram,
    addInstagram,
    handleSizeChange,
    instagramDetail,
    closeForm,
    initSortable,
    updateSortList,
    handleTableChange,
    handlePageChange,
    onPageChange(page, pageSize) {
      this.table.query.page = page;
      this.table.query.size = pageSize;
      this.getInstagramList();
    },
    onSizeChange(current, size) {
      this.table.query.page = 1;
      this.table.query.size = size;
      this.getInstagramList();
    },
  },
  mounted() {
    this.initSortable()
  },
  async created() {
    await this.getInstagramList();
  },
};
</script>

<style scoped>
.pagination-class {
  margin-right: 10px;
}
</style>
